import "./App.css";
import { RouterProvider, createBrowserRouter, useLoaderData, useLocation } from "react-router-dom";
import React, { Suspense } from "react";
import LoadingBackdrop from "../Components/LoadingBackdrop/LoadingBackdrop";
import { HelmetProvider } from "react-helmet-async";
import { baseRoutes, consoleRoutes } from "./routes";


const ConsoleRoute = React.lazy(() => import("./Console/ConsoleRoute"));
const PublicRoute = React.lazy(() => import("./Public/PublicRoute"));

const subdomain = window.location?.hostname?.split('.')?.[0];
const isConsole = subdomain === "app";

function RouteControl({ ...props }) {

  if (isConsole) {
    return <ConsoleRoute {...props} />
  } else {
    return <PublicRoute {...props} />
  }
}

const routes = isConsole ? consoleRoutes : baseRoutes;
const router = createBrowserRouter([
  {
    element: <RouteControl />,
    errorElement: <></>,
    children: routes,
  },
]);

function App() {
  return (
    <Suspense fallback={<LoadingBackdrop open={true} />}>
      <HelmetProvider>
        <RouterProvider router={router} />
      </HelmetProvider>
    </Suspense>
  );
}

export default App;
